import { createApp } from 'vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'

import App from './App.vue'
import router from "./router";
import store from "./store"; //2022/3/29 simon 新增
import axios from "@/help/axios";//2022/3/29 simon 修改過
import api from "@/service/api"; // 第二步驟會用到
import VueAxios from "vue-axios";



import PrimeVue from "primevue/config";
 
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);


import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "primeflex/primeflex.css";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import Checkbox from 'primevue/checkbox';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Paginator from "primevue/paginator";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import InputNumber from 'primevue/inputnumber';
import Textarea from "primevue/textarea";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import MultiSelect from "primevue/multiselect";
import ProgressSpinner from 'primevue/progressspinner';
import RadioButton from 'primevue/radiobutton';
import Breadcrumb from 'primevue/breadcrumb';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';


import Loading from 'vue-loading-overlay'//2022/3/29 simon 新增
import 'vue-loading-overlay/dist/vue-loading.css'//2022/3/29 simon 新增
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';



import DateRange from "./common/DateRange.vue";
import DateSingle from "./common/DateSingle.vue";
import TextSingle from "./common/TextSingle.vue";
import NumberSingle from "./common/NumberSingle.vue";



import TextMulti from "./common/TextMulti.vue";
import YesNoSingle from "./common/YesNoSingle.vue";
import PrintType from "./common/PrintType.vue";
import HCTEdelnoType from "./common/HCTEdelnoType.vue";
import CheckboxSingle from "./common/CheckboxSingle.vue";


import Modal_ImpAWB from "./modal/Modal_ImpAWB.vue";
import Modal_ExpAWB from "./modal/Modal_ExpAWB.vue";

import AgentEscsno from "./components/AgentEscsno.vue";
import Modal_AgentEscsno from "./modal/Modal_AgentEscsno.vue";
import AgentHCTedelnoRange from "./components/AgentHCTedelnoRange.vue";
import Modal_AgentHCTedelnoRange from "./modal/Modal_AgentHCTedelnoRange.vue";
import AgentHCTCustEdelnoRange from "./components/AgentHCTCustEdelnoRange.vue";
import Modal_AgentCustHCTedelnoRange from "./modal/Modal_AgentCustHCTedelnoRange.vue";

import BtnDownloadSendReport from "./components/BtnDownloadSendReport.vue";
import BtnUploadSendReport from "./components/BtnUploadSendReport.vue";
import AreaCodeAudioUpload from "./components/AreaCodeAudioUpload.vue";

import BtnUploadExpGoodsStatus from "./components/BtnUploadExpGoodsStatus.vue";


import BtnDownloadStatusClearReport from "./components/BtnDownloadStatusClearReport.vue";


import HCTedelno from "./components/HCTedelno.vue";



const app = createApp(App);
// eslint-disable-next-line vue/multi-word-component-names

//2022/3/29 simon 修改過
app.use(store).use(router).use(VueAxios, axios);
// Make BootstrapVue available throughout your project


app.use(PrimeVue).use(ToastService);
app.use(ConfirmationService);

app.component("font-awesome-icon", FontAwesomeIcon);

app.component("PrimeCheckbox", Checkbox);
app.component("PrimeDataTable", DataTable);
app.component("PrimeColumn", Column);
app.component("PrimePaginator", Paginator);
app.component("PrimeButton", Button);
app.component("PrimeDialog", Dialog);
app.component("PrimeToast", Toast);
app.component("PrimeCalendar", Calendar);
app.component("PrimeInputText", InputText);
app.component("PrimeInputNumber", InputNumber);

app.component("PrimeTextarea", Textarea);
app.component("PrimeDropdown", Dropdown);
app.component("PrimeFileUpload", FileUpload);
app.component("PrimeMultiSelect", MultiSelect);
app.component("PrimeProgressSpinner", ProgressSpinner);
app.component("PrimeRadioButton", RadioButton);
app.component("PrimeConfirmDialog", ConfirmDialog);
app.component("PrimeBreadcrumb", Breadcrumb);
app.component("PrimeTabView", TabView);
app.component("PrimeTabPanel", TabPanel);

 


// Optionally install the BootstrapVue icon components plugin
app.component('VueLoading', Loading);//2022/3/29 simon 新增
// 

app.component('my-date-range', DateRange);
app.component('my-date-single', DateSingle);
app.component('my-text-single', TextSingle);
app.component('my-number-single', NumberSingle);



app.component('my-text-multi', TextMulti);
app.component('my-yesno-single', YesNoSingle);
app.component('my-printtype', PrintType);
app.component('hct-edelnotype', HCTEdelnoType);

app.component('my-checkbox-single', CheckboxSingle);

app.component('my-modal-impawb', Modal_ImpAWB);
app.component('my-modal-expawb', Modal_ExpAWB);


app.component('my-agent-escsno', AgentEscsno);
app.component('my-modal-agentescsno', Modal_AgentEscsno);
app.component('my-agent-hctedelno-range', AgentHCTedelnoRange);
app.component('my-modal-agent-hctedelno-range', Modal_AgentHCTedelnoRange);
app.component('my-agent-cust-hctedelno-range', AgentHCTCustEdelnoRange);
app.component('my-modal-agent-cust-hctedelno-range', Modal_AgentCustHCTedelnoRange);
app.component('my-hctedelno', HCTedelno);

app.component('btn-download-sendreport', BtnDownloadSendReport);
app.component('btn-upload-sendreport', BtnUploadSendReport);
app.component('areacode-audioupload', AreaCodeAudioUpload);
app.component('btn-download-statusclearreport', BtnDownloadStatusClearReport);

app.component('btn-upload-expgoodsstatus', BtnUploadExpGoodsStatus);



app.config.globalProperties.array_addItem = (array, item) => {
    array.push(item);
  };
  app.config.globalProperties.array_updateItem = (array, item, keyField) => {
    console.log('array_updateItem')

    const index = array.findIndex((element) => {
      console.log(element[keyField])
      console.log(item[keyField])

      return element[keyField] == item[keyField]
     });
    console.log(index)

    array.splice(index, 1, item);
  };
  app.config.globalProperties.array_deleteItem = (array, item, keyField) => {

    const index = array.findIndex((element) => {
      return element[keyField] == item[keyField]
    });
    array.splice(index, 1);
  };
app.config.globalProperties.$api = api; // 定義api這個常數給AXIOS存取json-server或實際api環境用
app.mount("#app");

